/**
 * Collection of helpers / utils around core JS / ES.
 */
const JsUtil = {
  /**
   * Checks if given input is a String.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isString (candidate) {
    return Object.prototype.toString.call(candidate) === '[object String]'
  },

  /**
   * Checks if the given input is an object.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isObject (candidate) {
    return candidate && typeof candidate === 'object' && candidate.constructor === Object;
  },

  /**
   * Checks if the given input is a number. Returns false for non-finite numbers.
   *
   * @param {*} candidate
   * @returns true/false
   */
  isNumber (candidate) {
    return typeof candidate === 'number' && isFinite(candidate);
  },

  /**
   * Checks if the given input is numeric.
   *
   * @param {*} candidate Examples: 1, '1', '2.34'
   * @returns true/false
   */
  isNumeric (candidate) {
    return !isNaN(parseFloat(candidate)) && isFinite(candidate);
  },

  /**
   * Clones a JS object.
   *
   * @param {Object} obj
   * @returns The cloned object
   */
  cloneObject (obj) {
    return JSON.parse(JSON.stringify(obj));
  },

  /**
   * Removes the given property from the given object. The operation is not
   * taken in place but on a cloned object, which will be returned.
   *
   * @param {Object} obj
   * @param {String} prop
   * @returns Object clone with removed property
   */
  removePropFromObject (obj, prop) {
    return JSON.parse(JSON.stringify(
      obj,
      (key, val) => (key === prop) ? undefined : val)
    );
  },

  /**
   * Returns a random Integer between the given min/max values (included).
   *
   * @param {Number} min Min. Integer included
   * @param {Number} max Max. Integer included
   * @returns Random Integer in the given range
   */
  randomIntFromInterval (min, max) { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  /**
   * Replaces {0}, {1}, ... occurrences in the given string with the given
   * arguments in args1.
   *
   * @param {String} str
   * @param  {...String} args1
   * @returns The replaced string
   */
  formatString (str, ...args1) {
    // store arguments in an array
    const args = args1;

    if (!str) {
      return;
    }

    // use replace to iterate over the string
    // select the match and check if the related argument is present
    // if true, replace the match with the argument
    return str.replace(/{([0-9]+)}/g, (match, idx) => {
      // check if the argument is present
      return typeof args[idx] === 'undefined' ? match : args[idx];
    });
  }
}

export default JsUtil;



// WEBPACK FOOTER //
// ./app/util/JsUtil.js